import type { SharePayload, ShareResponse } from '@sdk/payload.types'

/**
 * Dispatch iOS sharing dialog.
 *
 * @example
 * api.share({text: "example text", subject: "example subject"})
 */
export async function share(payload: SharePayload): Promise<ShareResponse> {
  return this.API.request('share', payload)
}
